import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import BooleanField, { BooleanFieldProps } from '@components/base/input/BooleanField';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

type FilterInputsProps = Pick<BooleanFieldProps, 'aria-label' | 'onChange' | 'value'>;

const FilterBooleanField: FC<FilterInputsProps> = props => {
  const { t } = useTranslation();
  const { isReadonly } = useSearchAndFilter();

  const options: BooleanFieldProps['options'] = [
    { label: t('boolean', { context: 'true' }), value: 'True' },
    { label: t('boolean', { context: 'false' }), value: 'False' },
  ];

  return <BooleanField disabled={isReadonly} {...props} options={options} />;
};

export default FilterBooleanField;
